import { For, Show } from 'solid-js';
import { state, setMode, setTemplate, togglePalette, showModal, peers, connStatus, toggleNotifCenter, toastHistory } from '../state';
import { TEMPLATES } from '../templates/registry';
import { saveAs } from '../files/fsa';
import { pushToast } from '../state';
import { getIdentity } from '../collab/identity';

function connLabel(s: string): string {
  if (s === 'connected') return 'Live';
  if (s === 'connecting') return 'Connecting…';
  if (s === 'offline') return 'Offline';
  return 'Local';
}

export function Toolbar() {
  const openIsRoom = () => state.openKind === 'room';
  const openTitle = () => {
    if (!state.openId) return 'untitled.md';
    if (state.openKind === 'file') return state.files.find((f) => f.id === state.openId)?.title ?? '—';
    if (state.openKind === 'room') return state.rooms.find((r) => r.id === state.openId)?.title ?? '—';
    return '—';
  };

  const onExport = async () => {
    const ok = await saveAs(state.doc, openTitle().endsWith('.md') ? openTitle() : `${openTitle()}.md`);
    if (ok) pushToast({ severity: 'success', title: 'Exported to disk' });
  };

  const onShare = () => {
    if (state.openKind === 'room') {
      pushToast({
        severity: 'info',
        title: 'Share link',
        body: `${location.origin}/#room=${state.rooms.find((r) => r.id === state.openId)?.roomId}`,
        actions: [{
          label: 'Copy',
          run: () => {
            const r = state.rooms.find((x) => x.id === state.openId);
            if (r) navigator.clipboard?.writeText(`${location.origin}/#room=${r.roomId}`).catch(() => {});
            pushToast({ severity: 'success', title: 'Link copied' });
          },
        }],
        sticky: true,
      });
    } else if (state.openId) {
      showModal('share', state.openId);
    }
  };

  return (
    <header class="toolbar">
      <div class="toolbar-left">
        <span class="brand">md</span>
        <span class="file-name">
          {openTitle()}
          <span class={`badge ${openIsRoom() ? 'room' : 'local'}`}>{openIsRoom() ? 'ROOM' : 'LOCAL'}</span>
        </span>
        <span class={`save-pill ${state.saveStatus}`}>
          {state.saveStatus === 'saving' ? 'Saving…' : state.saveStatus === 'saved' ? 'Saved' : ''}
        </span>
        <Show when={state.openKind === 'room'}>
          <span class={`conn-pill ${connStatus()}`} title={connLabel(connStatus())}>
            <span class="conn-dot" />
            {connLabel(connStatus())}
          </span>
        </Show>
      </div>
      <div class="toolbar-center">
        <div class="seg">
          <button class={state.mode === 'edit' ? 'on' : ''} onClick={() => setMode('edit')} title="Edit only (Cmd-1)">Edit</button>
          <button class={state.mode === 'split' ? 'on' : ''} onClick={() => setMode('split')} title="Split (Cmd-2)">Split</button>
          <button class={state.mode === 'preview' ? 'on' : ''} onClick={() => setMode('preview')} title="Preview (Cmd-3)">Preview</button>
        </div>
        <select class="template-picker" value={state.template} onChange={(e) => setTemplate(e.currentTarget.value)}>
          {TEMPLATES.map((t) => <option value={t.id}>{t.name}</option>)}
        </select>
      </div>
      <div class="toolbar-right">
        <Show when={state.openKind === 'room'}>
          <div class="presence">
            <div class="avatar self" style={{ '--c': getIdentity().color }} title={getIdentity().name}>
              {getIdentity().name.split(' ').map((s) => s[0]).join('').slice(0, 2).toUpperCase()}
            </div>
            <For each={peers()}>
              {(p) => (
                <div class="avatar" style={{ '--c': p.color }} title={p.name}>
                  {p.name.split(' ').map((s) => s[0]).join('').slice(0, 2).toUpperCase()}
                </div>
              )}
            </For>
          </div>
        </Show>
        <Show when={state.openId}>
          <button onClick={onShare} title="Share">Share</button>
        </Show>
        <button class="ghost" onClick={onExport} title="Export to disk">Export…</button>
        <button class="bell" onClick={() => toggleNotifCenter()} title="Notifications">
          🔔
          <Show when={toastHistory().length > 0}>
            <span class="bell-count">{toastHistory().length > 9 ? '9+' : toastHistory().length}</span>
          </Show>
        </button>
        <button onClick={() => togglePalette(true)} title="Command palette (Cmd-K)">⌘K</button>
      </div>
    </header>
  );
}
